// extracted by mini-css-extract-plugin
export default {"modalOverlay":"UB-z","modalContent":"VB-z","header":"WB-z","close":"XB-z"};